const floatingAdjust = ( type, value, fixed ) => {
	const f = parseInt( fixed );
	
	if ( f === 0 )
	{
		return String( Math[type]( value ) );
	}

	const v = String( value ).split( '.' );

	let afterDot = v[1].slice( 0, f + 1 );

	while ( afterDot.length < f + 1 )
	{
		afterDot += 0;
	}

	afterDot = afterDot.split( '' );

	let afterDotString = '';

	if ( type === 'round' )
	{
		afterDotString = `${Math.round( Number( afterDot.join( '' ) ) / 10 )}`;
	}
	else
	{
		for ( const [i, it] of afterDot.entries() )
		{
			if ( i === f )
			{
				break;
			}

			afterDotString += it;
		}

		if ( type === 'ceil' && afterDot[f] > 0 )
		{
			afterDotString = String( Number( afterDotString ) + 1 );
		}
	}

	const r = v.length === 1 ? v[0] : `${v[0]}.${afterDotString}`;

	return Number( r ).toFixed( f );
};

export const floatingCeil = ( value, fixed ) => {
	return floatingAdjust( 'ceil', value, fixed );
};

export const floatingFloor = ( value, fixed ) => {
	return floatingAdjust( 'floor', value, fixed );
};

export const floatingRound = ( value, fixed ) => {
	return floatingAdjust( 'round', value, fixed );
};
